import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { User } from "../types/User";
import { env } from "../utils/env";

interface Params
  extends Omit<
    User,
    "groups" | "division" | "active_division" | "team" | "active_team"
  > {
  groups: number[];
  division: number[];
  active_division: number[];
  team: number[];
  active_team: number[];
}

export const useUpdateUserDetails = () => {
  const { authHeader } = useAuth();

  return useMutation((params: Partial<Params>) => {
    return axios.patch(
      `${env.verifyServiceUrl}user/user/${params.id}/`,
      params,
      {
        headers: {
          Authorization: authHeader,
        },
      }
    );
  });
};
